import { AfterViewInit, Component, OnInit, ViewChild, NgZone, ElementRef, VERSION, Renderer2, Inject, Input, ViewChildren, QueryList } from "@angular/core";
import { HttpClient, HttpResponse } from "@angular/common/http";
import { Subject } from "rxjs";
import { HttpClientModule } from "@angular/common/http";
import { DataTableDirective } from "angular-datatables";
import { DOCUMENT } from '@angular/common';
import { logbaseService } from "../../services/logbase.service";
import { dataService } from "../../services/data.service";
import { DatePipe } from "@angular/common";
import { NgxSpinnerService } from "ngx-spinner";
import { NgbModal, ModalDismissReasons, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-package-revision",
  templateUrl: "./package-revision.component.html",
  styleUrls: ["./package-revision.component.scss"]
})
export class PackageRevisionComponent implements AfterViewInit, OnInit {
  lineNumber: any;
  itemDetails: any;
  approvedListNew: any;
  disableROw: boolean;
  pkgRequestedList: any;
  pkgRequested: any;
  loggedInUser: any;
  pkgId: any;
  requestedItems: any;
  approvedTableTriggered: boolean;
  pkgCommentError: boolean;
  revisionComment: string;
  revisionList: any = [];
  appClosedList: any;
  partStatusList: any;
  approvedList: any;
  partStatus: any;
  suppCode: any;
  suppCodeList: any;
  suppCodeVal: any;
  userRoleID: any;
  parts: any;
  dtElements: QueryList<any>;
  dtTriggerUnlisted: Subject<any> = new Subject();
  dtTriggerApproved: Subject<any> = new Subject();
  dtTriggerRequested: Subject<any> = new Subject();
  dtOptions: DataTables.Settings[] = [];
  @ViewChildren(DataTableDirective)
  // @ViewChild(DataTableDirective)
  // dtOptions: DataTables.Settings = {};
  // dtTrigger: Subject<any> = new Subject();
  todayDate: any;
  newPartsCount: number;
  totalPartsCount: number;
  datatableElement: DataTableDirective;
  modalRef: NgbModalRef;
  searchText: any;


  constructor(
    private http: HttpClient, @Inject(DOCUMENT) private document: any, private logbaseService: logbaseService, private dataService: dataService,
    private spinner: NgxSpinnerService, private modalService: NgbModal, private renderer: Renderer2,
    private toaster: ToastrService, private translate: TranslateService) { }

  ngOnInit(): void {
    this.spinner.show();
    this.dtOptions[0] = {
      pagingType: "simple_numbers",
      dom:
        '<"top"<"row"<"col-md-10 text-right"<"#dtpagination"p>><"col-md-2 text-right"<"#dtlength"l>><"clear">>>t<"bottom"<"clear">>',
      order: [[3, "desc"]],
      language: {
        emptyTable: this.translate.instant('No Records Found'),
        search: "_INPUT_",
        searchPlaceholder: "  Search by: Part Number, Part Name...",
        paginate: {
          first: "",
          last: "",
          previous: "<",
          next: ">"
        }
      },
      rowCallback: (row: Node, data: any[] | Object, index: number) => {
        const self = this;
        // Unbind first in order to avoid any duplicate handler
        // (see https://github.com/l-lin/angular-datatables/issues/87)
        $("td", row).unbind("click");
        $("td", row).bind("click", () => {
          //self.someClickHandler(data);
        });
        return row;
      }
    };
    this.dtOptions[1] = {
      pagingType: "simple_numbers",
      dom:
        '<"top"<"row"<"col-md-10 text-right"<"#dtpagination"p>><"col-md-2 text-right"<"#dtlength"l>><"clear">>><"#dtSearch"f>t<"bottom"<"clear">>',
      order: [[3, "desc"]],
      language: {
        emptyTable: this.translate.instant('No Records Found'),
        search: "_INPUT_",
        searchPlaceholder: this.translate.instant("filter all columns"),
        paginate: {
          first: "",
          last: "",
          previous: "<",
          next: ">"
        }
      },
      rowCallback: (row: Node, data: any[] | Object, index: number) => {
        const self = this;
        // Unbind first in order to avoid any duplicate handler
        // (see https://github.com/l-lin/angular-datatables/issues/87)
        $("td", row).unbind("click");
        $("td", row).bind("click", () => {
          //self.someClickHandler(data);
        });
        return row;
      }
    };
    this.todayDate = Date.now();
    let userDetails = localStorage.getItem("userDetails");
    let userDetJson = JSON.parse(userDetails);
    this.userRoleID = userDetJson.userRoleMappings[0].roleId.toString();
    if (this.userRoleID != 4) {
      this.suppCodeVal = userDetJson.supplierCode.toString();
      this.suppCodeList = this.suppCodeVal.split(",");
      this.suppCode = this.suppCodeList[0];
    }
    else {
      this.suppCodeList = []
    }

    if (this.userRoleID == 4) {
      this.lineNumber = userDetJson.lineNumbers;
    }
    else {
      this.lineNumber = []
    }
    // To show supplier codes in supplier dropdown list for SM, log, operation

    this.loggedInUser = userDetJson.loginId;
    this.approvedTableTriggered = true;
    // this.getApprovedList();
    if (this.userRoleID == 1) {
      this.getRequestedList();
    }
  }

  getApprovedList() {

    let userDetails=localStorage.getItem('userDetails');
    let userDetailsObj:any=JSON.parse(userDetails);
    let supCode:any;
    let supplierCodeShortList=[];
    supplierCodeShortList=userDetailsObj.supplierCode;
    /*if(userDetailsObj.userRoleMappings[0].roleId==1)
    {
    supCode=userDetailsObj.supplierCode[0];
    supplierCodeShortList.push(supCode);
    }
    else
    {
      let partStatus=localStorage.getItem('partStatusSuppCode');
      let partStatuJsobj=[];
      partStatuJsobj=JSON.parse(partStatus);
      supplierCodeShortList=partStatuJsobj.map(objx1=>objx1.itemName);
    }*/
   
   
    var dataToSend =
    {
      filteredDeliveryPoints: [],
      filteredLineNumbers: [],
      filteredSupplierCode: [],
      filteredSupplierName: [],
      lineNumbers: this.lineNumber,
      pageNum: 0,
      partStatus: "approved",
      roleId: this.userRoleID,
      searchValue: this.searchText,
      size: 100,
      sortColumn: "updatedDate",
      sortType: "DESC",
      supplierCodes: supplierCodeShortList
    }
    this.logbaseService.partStatusWtPaging(dataToSend).subscribe(
      result => {
        this.partStatusList = result;
        this.approvedList = this.partStatusList.response.content;

        this.spinner.hide();

        if (this.approvedTableTriggered == true) {
          this.dtTriggerApproved.next(true);
        }
        if (this.userRoleID == 3 || this.userRoleID == 4 || this.userRoleID == 7 || this.userRoleID==1) {
          this.getRequestedPkgId()
        }
      }
    )
  }

  getRequestedList() {
    this.logbaseService.getRevRequestedPkg().subscribe(
      result => {
        this.partStatusList = result;
        this.requestedItems = this.partStatusList.response;
        this.dtTriggerRequested.next(true);
      });
  }

  getRequestedPkgId() {
    this.logbaseService.getRequestedPkg().subscribe(
      result => {
        this.pkgRequested = result;
        let packageReq = this.pkgRequested.response;

        const objMap = {};

        this.approvedList.forEach((e1) => packageReq.forEach((e2) => {
          if (e1.packageId === e2) {
            e1["disabled"] = true;
            // // Remove requested package list from approved List
            // this.approvedList = this.approvedList.filter(item => item.packageId !== e2);
          }
        }
        ));
      })
  }

  getSearchData() {
    this.spinner.show();
    this.approvedTableTriggered = false;
    this.getApprovedList();
  }

  openModal(detailPage, item) {
    this.itemDetails = item;
    this.pkgId = item.packageId;
    this.modalRef = this.modalService.open(detailPage,{backdrop:false})
    this.modalRef.result.then((result) => {
    });
  }

  onCommentEnter() {
    if (this.revisionComment == '') {
      this.pkgCommentError = true;
    } else {
      this.pkgCommentError = false;
    }
  }

  submitRequest() {
    this.approvedTableTriggered = false
    let dataTosend = {
      packageId: this.itemDetails.packageId,
      status: "requested",
      comment: this.revisionComment,
      userId: this.loggedInUser,
      supplierCode: this.itemDetails.supplierCode,
      lineNumber: this.itemDetails.lineNumber,
      deliveryPoint: this.itemDetails.deliveryPoint,
      partNumber: this.itemDetails.partNumber,
      partName: this.itemDetails.partName,
      changedBy: this.loggedInUser
    }
    this.logbaseService.submitRevisionRequest(dataTosend).subscribe(
      result => {
        this.modalRef.close();
        this.toaster.success(this.translate.instant('PKG_REV_REQUEST_SUCCESS'));
        this.getApprovedList();
        // this.getRequestedPkgId();
      })
  }



  ngAfterViewInit(): void {
    this.spinner.hide();
  }
}
